export default __webpack_public_path__ + "static/media/bgImage.5d87a0ce.png";